<template>
  <div>
    <div class="legal-hero">
      <div class="col">
        <div class="legal-eyebrow">Legal</div>
        <h1 class="legal-title">Política de Cookies</h1>
      </div>
    </div>
    <div class="col legal-col">
      <div class="legal-bloco" v-revela>
        <p class="legal-updated">Última atualização: julho de 2026</p>

        <h3 class="legal-h">O que são cookies</h3>
        <p class="legal-p">Cookies são pequenos arquivos armazenados no seu navegador que ajudam sites a funcionar corretamente e a entender como são utilizados.</p>

        <h3 class="legal-h">Cookies que usamos</h3>
        <p class="legal-p">Este site usa apenas cookies essenciais ao funcionamento — como preferências básicas de navegação. Não utilizamos cookies de publicidade nem rastreadores de terceiros para fins de marketing.</p>

        <h3 class="legal-h">Serviços de terceiros</h3>
        <p class="legal-p">O mapa de cobertura é fornecido pelo Google Maps, que pode definir cookies próprios conforme a política do Google. As fontes tipográficas são carregadas via Google Fonts.</p>

        <h3 class="legal-h">Como gerenciar</h3>
        <p class="legal-p">Você pode bloquear ou excluir cookies nas configurações do seu navegador a qualquer momento. O site continua funcional sem cookies não essenciais.</p>

        <h3 class="legal-h">Contato</h3>
        <p class="legal-p">Dúvidas sobre esta política podem ser enviadas pelos canais informados no rodapé do site.</p>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style src="@/assets/legal.css" scoped></style>
